/**
 * 显示版本号弹窗高阶组件
 * created by: liyaoh 2020-07-13
 */
import React from 'react';
import SelectVaryModal from '../../../../uap/public/packages/ctmsmodal/ShowVaryIDModal';

export default function withVaryModal(onVaryConfirm) {
    return function(WrapperComponent) {
        return class extends React.Component {
            constructor(props) {
                super(props);
                this.state = {
                    showVaryModal: false,
                    flag: 'pagetemplate'
                };
            }
    
            showVaryModal = (flag = 'pagetemplate', operate) => {
                this.setState({ 
                    showVaryModal: true,
                    flag,
                    operate
                });
            }
    
            onConfirm = (varyId = '') => {
                if(typeof onVaryConfirm === 'function') {
                    //将包裹组件的引用传出去
                    onVaryConfirm(varyId, this.component, this.state.operate);
                }
            };
    
            render() {
                const newProps = {
                    showVaryModal: this.showVaryModal,
                    ...this.props
                }
                return (
                    <React.Fragment>
                        <WrapperComponent ref={ref => this.component = ref} {...newProps}/>
                        {this.state.showVaryModal && (
                            <SelectVaryModal
                                flag={this.state.flag}
                                close={() => this.setState({ showVaryModal: false })}
                                confirm={this.onConfirm}
                            />
                        )}
                    </React.Fragment>
                );
            }
        };
    }
}
